import { render, staticRenderFns } from "./BringupsOverdue.vue?vue&type=template&id=57ed9b3d"
import script from "./BringupsOverdue.vue?vue&type=script&lang=js"
export * from "./BringupsOverdue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports